// @flow
import * as Immutable from 'immutable';
import FpPlanViewActions from 'common/redux/actions/FpPlanViewActions';
import { FpPjPlan } from 'common/models/internal/FpPjPlan';

export const fpPlanView = (state = Immutable.fromJS({}), action) => {
    switch (action.type) {
        case FpPlanViewActions.FETCH_FP_PLAN_START: {
            let newState = state.setIn(['plan', 'isLodaing'], true);
            newState = newState.setIn(['plan', 'entity'], null);
            newState = state.setIn(['salesbeatPlan', 'isLodaing'], true);
            return newState;
        }
        case FpPlanViewActions.FETCH_FP_PLAN_SUCCESS: {
            const { plan } = action;
            let newState = state.setIn(['plan', 'isLodaing'], false);
            const allOutlets = [...plan.outletVisits];
            const visitIdMap = allOutlets.reduce((acc, outlet) => {
                return acc.set(outlet.id, outlet);
            }, new Immutable.Map());
            newState = newState.setIn(
                ['plan', 'entity'],
                FpPjPlan.fromJS(plan)
            );
            newState = newState.setIn(['salesbeatPlan', 'isLoading'], false);
            newState = newState.setIn(
                ['salesbeatPlan', 'entity'],
                plan.salesbeatPlan
            );
            newState = newState.setIn(['visitIdMap'], visitIdMap);
            return newState;
        }
        case FpPlanViewActions.FETCH_FP_PLAN_FAILURE: {
            const { error } = action;
            let newState = state.setIn(['plan', 'isLodaing'], false);
            newState = newState.setIn(['plan', 'error'], error);
            return newState;
        }
        case FpPlanViewActions.FETCH_FP_SALESBEAT_PLAN_START: {
            const newState = state.setIn(['salesbeatPlan', 'isLoading'], true);
            return newState;
        }
        case FpPlanViewActions.FETCH_FP_SALESBEAT_PLAN_SUCCESS: {
            const { salesbeatPlan } = action;
            let newState = state.setIn(['salesbeatPlan', 'isLoading'], false);
            newState = newState.setIn(
                ['salesbeatPlan', 'entity'],
                salesbeatPlan
            );
            return newState;
        }
        case FpPlanViewActions.MOVE_VISIT_START: {
            const newState = state.setIn(['salesbeatPlan', 'isLoading'], true);
            return newState;
        }
        case FpPlanViewActions.MOVE_VISIT_SUCCESS: {
            const { salesbeatPlan } = action;
            let newState = state.setIn(['salesbeatPlan', 'isLoading'], false);
            newState = newState.setIn(
                ['salesbeatPlan', 'entity'],
                salesbeatPlan
            );
            return newState;
        }
        case FpPlanViewActions.MOVE_VISIT_FAILURE: {
            const { error } = action;
            let newState = state.setIn(['salesbeatPlan', 'isLoading'], false);
            newState = newState.setIn(['salesbeatPlan', 'error'], error);
            return newState;
        }
        case FpPlanViewActions.EDIT_VISIT_SUCCESS: {
            const { salesbeatPlan } = action;
            const editedSbPlan = salesbeatPlan; // FIXME: Change it to FpSalesbeatPlan model
            const newState = state.setIn(
                ['salesbeatPlan', 'entity'],
                editedSbPlan
            );
            return newState;
        }

        case FpPlanViewActions.OUTELT_SALES_CATEGORY_FETCH_IN_PROGRESS: {
            let newState = state.setIn(
                ['outletSalesCategories', 'isLoading'],
                true
            );
            newState = newState.setIn(
                ['outletSalesCategories', 'entity'],
                null
            );
            return newState;
        }

        case FpPlanViewActions.OUTELT_SALES_CATEGORY_FETCH_SUCCESS: {
            const { salesCategories } = action;
            let newState = state.setIn(
                ['outletSalesCategories', 'isLoading'],
                false
            );
            newState = newState.setIn(
                ['outletSalesCategories', 'entity'],
                salesCategories
            );
            return newState;
        }
        case FpPlanViewActions.OUTELT_SALES_CATEGORY_FETCH_ERROR: {
            const { error } = action;
            let newState = state.setIn(
                ['outletSalesCategories', 'isLoading'],
                false
            );
            newState = newState.setIn(
                ['outletSalesCategories', 'entity'],
                null
            );
            newState = newState.setIn(
                ['outletSalesCategories', 'error'],
                error
            );

            return newState;
        }
        case FpPlanViewActions.CLEAR_ALL_FP_DATA: {
            let newState = state.setIn(['salesbeatPlan', 'isLoading'], false);
            newState = newState.setIn(['salesbeatPlan', 'error'], null);
            newState = newState.setIn(['salesbeatPlan', 'entity'], null);
            newState = newState.setIn(['plan', 'entity'], null);
            newState = newState.setIn(['plan', 'isLoading'], false);
            return newState;
        }
    }
    return state;
};
